import EditReleaseContainer from "../containers/EditReleaseContainer";

const EditReleasePage = () => {
  return (
    <EditReleaseContainer />
  );
};

export default EditReleasePage;
